<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <div class="association">
      <p class="association-title">产品链路</p>
      <img :src="i6" alt="" class="img-style">
    </div>
    <product-content
      :productContentArr = product
    />
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/association/1.png'
import i2 from '../assets/images/association/2.png'
import i3 from '../assets/images/association/3.png'
import i4 from '../assets/images/association/4.png'
import i5 from '../assets/images/association/5.png'
import i6 from '../assets/images/association/6.png'
export default {
  data () {
    return {
      i6: i6,
      product: [
        {img: i1, boxStyle: '', content: '前海智绘的设备联接技术通用于各种常见传输协议，各种联网方式和各种云基础设施平台。提供多种代理软件，适用于HTTPS、MQTT以及，，支持嵌入式方案、网关、Android、Linux、蓝牙手机，直接联接到云端', label: '终端设备接入，联网传输，数据上云', type: 'left', style: 'width: 3.38rem;padding-right:0.38rem;'},
        {img: i2, boxStyle: 'padding-left: 0.54rem;', content: '提供完整的设备生命周期管理功能，支持设备注册、功能定义、数据解析、在线调试、远程配置、固件升级、远程维护、实时监控、分组管理、设备删除等功能', label: '实时在线监控，远程OTA升级', type: 'right', style: 'width: 3.39rem;padding-left:0.28rem;'},
        {img: i3, boxStyle: '', content: '身份认证：<br/>提供一机一密的设备认证机制，降低设备被攻破的安全风险适合有能力批量预分配设备证书（ProductKey、DeviceNa-me和DeviceSecret），将设备证书信息烧入到每个芯片的设备地图与数据血缘实现360°数据全链路追踪<br/>通信安全：<br/>支持TLS（MQTT\\HTTP）数据传输通道，保证数据的机密性和完整性，适用于硬件资源充足、对功耗不是很敏感的设备支持设备权限管理机制，保障设备与云端安全通信支持设备级别的通信资源（Topic等）隔离，防止设备越权等问题', label: '多重防护，有力保障设备云端安全', type: 'left', style: 'width: 3.38rem;padding-right: 0.56rem;'},
        {img: i4, boxStyle: 'padding-left: 0.54rem;', content: '', label: '可视化报表，多维度交叉统计分析', type: 'right', style: 'width: 2.82rem;padding-left:0.28rem;'}
      ],
      bannerObj: {
        img: i5,
        title: '物联平台',
        content: '万物互联，数据为王 设备联营，智能分润<br/>设备监控与分润系统，聚焦设备资产智能运营',
        button: '业务咨询'
      },
      topIndex: 1,
      childrenIndex: 2,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    footerA,
    dialogBusiness
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.association-title{
  font-size:34px;
  font-family:PingFang SC;
  font-weight:bold;
  color:rgba(51,51,51,1);
  padding: 80px 0 30px;
}
.association{
  background:rgba(247,248,248,1);
  padding-bottom: 30px;
}
.img-style{
  width: 775px;
  height: 324px;
  text-align: center;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/association.vue